// Import polyfills - Thank you IE
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';

import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import getFromConfig from 'constants/config';
import { TYPES as ACCOUNT_TYPES } from 'account/modules/account';

import './styles.css';

const AUTH0_CLIENT_ID = getFromConfig('REACT_APP_AUTH0_CLIENT_ID');
const AUTH0_AUDIENCE = getFromConfig('REACT_APP_AUTH0_AUDIENCE');
const AUTH0_DOMAIN = getFromConfig('REACT_APP_AUTH0_DOMAIN');

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

/**
 * Returns the Auth0 connection to use, or undefined to respect existing session.
 * Only pass connection when explicitly in the URL (e.g. SSO login links).
 * When navigating from another app without ?connection=, we must not force a
 * connection—otherwise we'd override the user's existing auth with SSO.
 */
function getAuth0Connection() {
  const q_conn = getQueryVariable('connection');

  if (q_conn) {
    // Explicit connection in URL (e.g. SSO deep link)—use it for this session only.
    // Don't persist to localStorage to avoid forcing this connection on future
    // visits when the user navigates from other apps.
    return q_conn;
  }

  // No connection in URL: don't pass one. Let Auth0 use the existing session
  // from the browser (e.g. when user navigated from another app).
  return undefined;
}

const loginWithRedirect = props => {
  store.dispatch({ type: ACCOUNT_TYPES.SET_FRESH_LOGIN, returnTo: props?.returnTo || window.location.pathname });
};

const Root = ({ store }) => (
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENT_ID}
    audience={AUTH0_AUDIENCE}
    connection={getAuth0Connection()}
    redirectUri={window.location.origin}
    onRedirectCallback={loginWithRedirect}
    cacheLocation="localstorage"
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>
);

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
